<div class="dtf-accountdetails admin-invoice-page">
  <div class="dtf-alertpage"></div>

  <div *ngIf="bodyLoaded" class="mbfs-payoff-quote-spinner">
    <section class="mbfs-home-hero" style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">{{ 'LoaderPages.BannerHeader' | translate }}</h2>
        <p class="mbfs-home-hero__header-text-demi">{{ 'LoaderPages.Loading' | translate }}</p>
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"></div>
      </section>
    </section>
  </div>

  <div class="container_dashboard" *ngIf="!bodyLoaded">
    <div class="invoice-title-wrap">
      <h2 class="invoice-page-title">Invoice</h2>
    </div>

    <div class="lookup-card">
      <div class="lookup-main">
        <h3>Search Invoices</h3>
        <p>Find invoices by invoice number or customer and date.</p>

        <div class="search-mode">
          <label>Search By</label>
          <mat-radio-group [value]="searchMode" (change)="setSearchMode($event.value)">
            <mat-radio-button value="invoice">Invoice Number</mat-radio-button>
            <mat-radio-button value="customerDate">Customer + Date</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="search-input-row" *ngIf="searchMode === 'invoice'">
          <div class="search-field">
            <label for="invoiceNumber">Invoice Number</label>
            <input id="invoiceNumber" class="form-control" type="text" [(ngModel)]="invoiceNumber" autocomplete="off">
          </div>
        </div>

        <div class="search-input-row customer-row" *ngIf="searchMode === 'customerDate'">
          <div class="search-field">
            <label for="customerNumber">Customer Number</label>
            <input id="customerNumber" class="form-control" type="text" [(ngModel)]="customerNumber" autocomplete="off">
          </div>
          <div class="search-field date-field">
            <label for="startDate">Start Date</label>
            <mat-form-field appearance="outline" class="w-100">
              <input id="startDate" matInput [matDatepicker]="startDatePicker" [min]="minDate" [max]="currentDate" readonly [(ngModel)]="dateRangeStart" (dateChange)="onStartDateChange()">
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="search-field date-field">
            <label for="endDate">End Date</label>
            <mat-form-field appearance="outline" class="w-100">
              <input id="endDate" matInput [matDatepicker]="endDatePicker" [min]="getEndDateMin()" [max]="currentDate" readonly [(ngModel)]="dateRangeEnd" (dateChange)="onEndDateChange()">
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="search-actions">
          <button class="mbfs-button primary-action" type="button" (click)="getInvoice()">
            <mat-icon>search</mat-icon>
            Search
          </button>
          <button class="mbfs-button clear-action" type="button" (click)="clearAll($event)">Clear</button>
        </div>
      </div>
    </div>

    <div class="results-card">
      <div class="results-head">
        <h3>Results ({{ rowCount }} invoice found)</h3>
        <div class="results-actions" *ngIf="InvoiceFound">
          <button type="button" class="export-btn" (click)="onDownloadClick('.xlsx')">
            <img src="static/assets/img/dtf-assets/images/DTF_Icons/excel-icon.png" alt="excel">
            Export to Excel
          </button>
          <button type="button" class="export-btn" (click)="onDownloadClick('.pdf')">
            <img src="static/assets/img/dtf-assets/images/DTF_Icons/pdf.png" alt="pdf">
            Export to PDF
          </button>
        </div>
      </div>

      <div class="table-filter-field" *ngIf="rowCount > 0">
        <mat-form-field appearance="outline">
          <mat-label>Filter invoices...</mat-label>
          <input matInput (keyup)="applyFilter($event)" [(ngModel)]="value" type="text">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <div *ngIf="!invoiceLoaded" class="mbfs-payoff-quote-spinner inline-spinner">
        <div class="demo-container">
          <span>{{ 'Invoice.Loading' | translate }}</span>
          <div class="progress-bar"><div class="progress-bar-value"></div></div>
        </div>
      </div>

      <div class="invoice-table-shell mat-elevation-z1">
        <mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="contractNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Contract</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.contractNumber }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="consolidationNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Customer Number</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span matTooltip="{{ element.dba_fao_billingAdd }}">{{ element.consolidationNumber }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="invoiceNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Number</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.invoiceNumber }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="invoiceDueDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.invoiceDueDate | date:'MMM d, y' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="viewInvoice">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div class="invoice-actions">
                <button
                  type="button"
                  class="action-icon-btn"
                  (click)="onIconClick(element.invoiceNumber, '.pdf')"
                  matTooltip="Download PDF"
                >
                  <img src="static/assets/img/dtf-assets/images/DTF_Icons/pdf.png" alt="Download PDF">
                </button>

                <button
                  type="button"
                  class="action-icon-btn"
                  *ngIf="!isInvoiceTypeA(element.invoiceType)"
                  (click)="onIconClick(element.invoiceNumber, '.xlsx')"
                  matTooltip="Download Excel"
                >
                  <img src="static/assets/img/dtf-assets/images/DTF_Icons/excel-icon.png" alt="Download Excel">
                </button>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5"><b>{{ InvoiceErrorDesc || 'No invoice data found' }}</b></td>
          </tr>
        </mat-table>
      </div>

      <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
    </div>
  </div>
</div>